// @flow

import routes from 'app/get-help/routes';

export default {
  routes,
};
